<template>
  <v-app>
    <v-toolbar
    >

      <v-btn icon @click.stop="fixed = !fixed">
        <v-icon>remove</v-icon>
      </v-btn>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click.stop="rightDrawer = !rightDrawer">
        <v-icon>menu</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content  style="padding-top: 18px">
      <router-view/>
    </v-content>
    <v-footer :fixed="fixed" app  style="height: 70px">
      <v-container style="height: 80px" align-center justify-center>
        <v-layout justify-center>
          <v-flex xs1 md3>

          </v-flex>
          <v-flex xs10 md6 >
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span>(c) 2020</span> <a href="https://scienceofscience.org/" target="_blank">Tong Zeng, Daniel Acuna</a> from  &nbsp; &nbsp;


            <a href="http://ischool.syr.edu" target="_blank">
              <img src="@/assets/ischool_logo.png" width="200" style="background-color: transparent; border: none" class="img-responsive img-thumbnail"></a>

          </v-flex>
          <v-flex xs1 md3>

          </v-flex>
        </v-layout>
      </v-container>
    </v-footer>
  </v-app>
</template>

<style>
  .toolbar {
    -webkit-transition: none;
    transition: none;
    -webkit-box-shadow: 0 2px 4px -1px rgba(0,0,0,.05), 0 4px 5px 0 rgba(0,0,0,.05), 0 1px 10px 0 rgba(0,0,0,.05);
    box-shadow: 0 2px 4px -1px rgba(0,0,0,.05), 0 4px 5px 0 rgba(0,0,0,.05), 0 1px 10px 0 rgba(0,0,0,.05);
    display: block;
    position: relative;
    width: 100%;
    will-change: padding-left;
  }
</style>

<script>
export default {
  data () {
    return {
      fixed: false,
      right: true,
      title: 'Is there a citation needed?'
    }
  },
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue